/**
 * All posible type of EndPoint, this enum, has the diferente endpoint for send request
 */
export enum EndPointEnum {
  /**
   * Api of Yacare-Api
   */
  MagiisApi,
  TraslatorApi,
  NotificationsApi
}
